let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7VwsU"), load("fsZ6i"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("iOJdB")]).then(() => parcelRequire('452sv'));